import { useEffect, useState } from 'react';

/**
 * True only once `active` has stayed true for `delayMs`, so work that finishes
 * quickly never shows a loading state at all.
 */
export default function useDelayedFlag(active: boolean, delayMs = 300): boolean {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!active) {
            setVisible(false);

            return undefined;
        }

        const timer = setTimeout(() => setVisible(true), delayMs);

        return () => clearTimeout(timer);
    }, [active, delayMs]);

    return visible;
}
